export const OPERATING_MODES = {
  GEN_SET_PEAKSHAVE: 'GEN_SET_PEAKSHAVE',
  GEN_SET_CYCLE: 'GEN_SET_CYCLE', // -- genset
  LOADSHARE: 'LOADSHARE',
  CHARGE_ON_GENSET: 'CHARGE_ON_GENSET',
  SHUTDOWN: 'SHUTDOWN',
  GEN_SET_NIGHT_MODE: 'GEN_SET_NIGHT_MODE',
  STANDALONE: 'STANDALONE',
  GRID_PEAKSHAVE: 'GRID_PEAKSHAVE',
};

export const OPERATING_MODES_REQ_SCHEMAS = {
  GEN_SET_INPUT: {
    program_name: null,
    max_input_current: null,
    rated_power: null,
    eff_factor_high: null,
  },
  LOADSHARE: {
    program_name: null,
    max_input_current: null,
    type: null, // ["NONE", "WEAK_GRID", "STRONG_GRID", "GENSET"]
  },
  CHARGE_ON_GENSET: {
    program_name: null,
    target_soc: null,
  },
  SHUTDOWN: {
    program_name: null,
    shut_down_24v: null,
  },
  GENERIC: {
    program_name: null,
  },
  GRID_PEAKSHAVE: {
    program_name: null,
    max_input_current: null,
  },
};

export const CHAT_DEFAULT_WIDTH = 405;
export const LG_EXTENDED_WIDTH = 1600;
